import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import { Response } from "../interfaces/services/Response";

export const getComprovantePagamento = async (ano: number, codCartao: string, cpf: string, dtNasc: string, captchaToken: string): Promise<string> => {
  try {
    const response = await apiClientes.get('/ComprovantePagamento/GerarComprovPagReceb', 
      { 
        params: { 
          ano, 
          codCartao: codCartao || undefined, 
          dtNasc: !codCartao ? dtNasc : undefined,
          cpf,
          captchaToken
        },
        headers: { Authorization: `Bearer ${await getTokenClientes()}` } 
      });
    if (response?.data?.dados) {
      return response.data.dados.conteudo;
    } else {
      throw new Error(response.data.mensagem);
    }
  } catch (error: any) {
    console.log({ error });
    throw new Error(error.response.data.mensagem);
  }
};

